import { useState } from "react";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AllIssues from "./all-issues";
import TenantIssues from "./tenant-issues";
import ClientIssues from "./client-issues";
import InspectorIssues from "./inspector-issues";
import { useSelector } from "react-redux";
import { userType } from "../../../utils/Constant";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function TabLabel(data: any) {
  return (
    <>
      {data?.label}
      {data?.showWarning && (
        <InfoOutlinedIcon className="tab-label-warning-icon" />
      )}
    </>
  );
}

export default function OrderIssues() {
  const [value, setValue] = useState(0);

  const { currentUser } = useSelector((state: any) => state.user.user);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {currentUser?.userType !== userType.client && <ContactSpectrum />}
      <Box mt={currentUser?.userType === userType.client ? 2 : 0}>
        <Breadcrumb />
      </Box>
      <Typography sx={{ ml: 2, mt: 1 }} variant="h4">
        Issues
      </Typography>
      {currentUser?.userType === userType.tenant && (
        <Box sx={{ mt: 3, mx: 2 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="orders tabs"
            variant="scrollable"
            scrollButtons={false}
          >
            <Tab
              className="tab-label"
              label={<TabLabel label="All" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Internal" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Client" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Inspector" showWarning={false} />}
            />
          </Tabs>
        </Box>
      )}
      {currentUser?.userType === userType.client && <ClientIssues />}
      {currentUser?.userType === userType.inspector && <InspectorIssues />}

      {currentUser?.userType === userType.tenant && (
        <>
          <CustomTabPanel value={value} index={0}>
            <AllIssues />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <TenantIssues />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <ClientIssues />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <InspectorIssues />
          </CustomTabPanel>
        </>
      )}
    </>
  );
}
